import watchAccountGrMaster from 'modules/account-group-master/saga';
import watchAccountMaster from 'modules/account-master/saga';
import watchAirMaster from 'modules/airMasterBL/saga';
import watchAitGrMaster from 'modules/ait-group-master/saga';
import watchAuth from 'modules/auth/saga';
import watchBlMasterExport from 'modules/blMaster-export/saga';
import watchBlMaster from 'modules/blMaster/saga';
import watchCargoSearchExport from 'modules/cargo-trace-search-export/saga';
import watchCargoSearch from 'modules/cargo-trace-search/saga';
import watcChatroomInformation from 'modules/chatroom/saga';
import watchCommon from 'modules/common/saga';
import watchContainerStatus from 'modules/container-status/saga';
import watchCustomsClearanceRequestExport from 'modules/customs-clearance-request-export/saga';
import watchCustomsClearanceRequest from 'modules/customs-clearance-request/saga';
import watchDeliveryDestMaster from 'modules/delivery-dest-master/saga';
import watchMenuDisplayItem from 'modules/display-item-master/saga';
import watchDocumentApproval from 'modules/document-approval/saga';
import watchEdiSaga from 'modules/edi/saga';
import watchGeneralMaster from 'modules/general-master/saga';
import watchHblStatusExport from 'modules/hbl-status-export/saga';
import watchHblStatus from 'modules/hbl-status/saga';
import watchMenuAuthorityMaster from 'modules/menu-authority-master/saga';
import watchNotification from 'modules/notification/saga';
import watchOutputReportMaster from 'modules/output-report-search/saga';
import watchPortMaster from 'modules/port-master/saga';
import watchSearchPattern from 'modules/search-pattern/saga';
import watchShipMovement from 'modules/ship-movement-search/saga';
import watchStatusMaster from 'modules/status-master/saga';
import watchPreAlertExport from 'modules/trace-info-export/pre-alert/saga';
import watchPreAlert from 'modules/trace-info/pre-alert/saga';
import watchUserMast from 'modules/user-maintance/saga';
import { all } from 'redux-saga/effects';

function* rootSaga() {
  yield all([
    watchAuth(),
    watchAirMaster(),
    watchCommon(),
    watchBlMaster(),
    watchBlMasterExport(),
    watchShipMovement(),
    watchCargoSearch(),
    watchCargoSearchExport(),
    watchPreAlert(),
    watchPreAlertExport(),
    watchEdiSaga(),
    watchOutputReportMaster(),
    watchMenuDisplayItem(),
    watchUserMast(),
    watchAccountMaster(),
    watchGeneralMaster(),
    watchAccountGrMaster(),
    watchPortMaster(),
    watchSearchPattern(),
    watchDocumentApproval(),
    watchHblStatus(),
    watchHblStatusExport(),
    watchContainerStatus(),
    watcChatroomInformation(),
    watchAitGrMaster(),
    watchStatusMaster(),
    watchMenuAuthorityMaster(),
    watchCustomsClearanceRequest(),
    watchCustomsClearanceRequestExport(),
    watchDeliveryDestMaster(),
    watchNotification(),
  ]);
}
export default rootSaga;
